module.exports = __webpack_public_path__ + "img/facebook-32px.425d402e.svg";